import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Box,
  Button,
  Accordion,
  EmptyState,
} from '@cubeyou-team/hx-react-components';
import { StyledResultsEmptyStateContainer } from '../../TaxonomyExplorer.styles';
import { DemographicLoader } from '../ContentLoaders';
import DemographicsItems from '../DemographicsItems';
import { mapDemographicIcons, mapDemographicLabels } from './constants';

const StyledDemographicsContainer = styled.div`
  overflow: auto;
  height: 100%;
`;

const DemographicsContainer = ({
  demographics,
  isSearching,
  onDemographicSelected,
  onItemDragToggle,
  emptyDataMessage,
  specifiedComponents,
}: {
  isSearching?: boolean;
  emptyDataMessage?: string;
  demographics?: any;
  onDemographicSelected?: (item: any) => void;
  onItemDragToggle?: (v: boolean) => void;
  specifiedComponents: Record<string, any>;
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const isDemographicsLoaded = !demographics.isLoading || demographics.loaded;

  if (!isDemographicsLoaded) return <DemographicLoader />;

  if (isSearching) {
    if (demographics.demographicsSearchResults.length === 0) {
      return (
        <StyledResultsEmptyStateContainer>
          <EmptyState icon="search" mainText={emptyDataMessage} size="small" />
        </StyledResultsEmptyStateContainer>
      );
    }

    return (
      <StyledDemographicsContainer>
        <Box mT="large">
          <DemographicsItems
            type=""
            values={demographics.demographicsSearchResults}
            isDemographicsLoaded={isDemographicsLoaded}
            onDemographicSelected={onDemographicSelected}
            onItemDragToggle={onItemDragToggle}
          />
        </Box>
      </StyledDemographicsContainer>
    );
  }

  return (
    <StyledDemographicsContainer>
      <Accordion initialMultipleState={collapsed ? 'closed' : 'open'}>
        {demographics.data.map(demo => (
          <div
            /* @ts-ignore */
            label={mapDemographicLabels[demo.type]}
            key={`demo-group-${demo.type}`}
            icon={mapDemographicIcons[demo.type]}
          >
            {(specifiedComponents && specifiedComponents[demo.type]) || (
              <DemographicsItems
                type={demo.type}
                values={demo.values}
                isDemographicsLoaded={isDemographicsLoaded}
                onDemographicSelected={onDemographicSelected}
                onItemDragToggle={onItemDragToggle}
              />
            )}
          </div>
        ))}
      </Accordion>
      <Box pT="small" borderSize="1px" borderPosition="top">
        <Button variant="subtle" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? 'OPEN ALL' : 'COLLAPSE ALL'}
        </Button>
      </Box>
    </StyledDemographicsContainer>
  );
};

export default DemographicsContainer;
